import styled from "styled-components";

export const VOTING_PIE_CARD_HEIGHT = "160px";
export const VOTING_PIE_INNER_RADIUS = 0.78;
export const VOTING_PIE_MARGIN = {
  top: 12,
  right: 0,
  bottom: 4,
  left: 0,
};

export const VotingPieChartContainer = styled.div`
  flex: 0 0 88px;
  width: 88px;
  height: 88px;
  overflow: visible;
`;

export const VotingPieLegendContainer = styled.div`
  display: flex;
  flex: 1;
  height: 88px;
  margin-left: 12px;
  overflow-y: auto;
`;

export const VotingPieEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 88px;
  color: #8b909a;
  font-family: "Apercu", sans-serif;
  font-size: 12px;
`;